import { ReactNode } from "react";

interface MobileRefreshingListProps {
    isRefreshing: boolean;
    children: ReactNode;
    className?: string;
}

/*Keeps the list visible while it refetches, but dimmed and non-interactive, 
  so the user cannot act on outdated data*/

const MobileRefreshingList = ({ isRefreshing, children, className }: MobileRefreshingListProps) => (
    <div className={className}
    inert={isRefreshing}
    aria-busy={isRefreshing}
    style={{
        opacity: isRefreshing ? 0.5 : 1,
        transition: "opacity 150ms ease-in-out",
    }}
    >
        {children}
    </div>
);

export default MobileRefreshingList;